const mediaItems = [
  {
    title: '91影视看片app使用教程',
    desc: '从下载安装到功能上手，3分钟快速掌握全部操作技巧，新手必看指南',
    duration: '03:28',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20desktop%20workspace%20with%20a%20large%20monitor%20displaying%20a%20mobile%20app%20tutorial%20interface%20with%20step%20by%20step%20instructions%2C%20warm%20desk%20lamp%20lighting%2C%20organized%20setup%20with%20notebook%20and%20coffee%2C%20professional%20tutorial%20creation%20environment%2C%20warm%20neutral%20tones&width=640&height=360&seq=media-tutorial-01&orientation=landscape',
  },
  {
    title: '最新版本功能亮点一览',
    desc: 'v3.8.2全新特性展示：4K播放优化、智能字幕升级、投屏体验革新',
    duration: '05:15',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20floating%20in%20mid%20air%20with%20glowing%20feature%20icons%20and%20labels%20radiating%20around%20it%2C%20showing%20app%20update%20highlights%2C%20dark%20gradient%20background%20with%20warm%20gold%20accent%20glows%2C%20futuristic%20tech%20presentation%20style%2C%20clean%20minimal%20composition&width=640&height=360&seq=media-features-02&orientation=landscape',
  },
  {
    title: '用户真实观影体验分享',
    desc: '多位资深用户分享使用心得：为什么选择91影视看片app作为主力追剧工具',
    duration: '08:42',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20scene%20with%20friends%20gathered%20around%20watching%20a%20movie%20on%20a%20large%20screen%2C%20laughing%20and%20enjoying%20themselves%2C%20bowls%20of%20popcorn%20on%20the%20coffee%20table%2C%20warm%20evening%20atmosphere%2C%20ambient%20lamplight%2C%20lifestyle%20photography&width=640&height=360&seq=media-review-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩视频</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">观看视频了解更多，从入门到精通一次搞定</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={`91影视看片app - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-xs font-medium rounded bg-foreground-950/70 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}